<lcs-loading-overlay
   class="flex-dir-col"
   [show]="callState | lcsCallState : 'loading'"
   *ndtErrorPage="!(callState | lcsCallState : 'error'); entityName: 'ExtensionGroup'"
>
   <div class="detail-page-headerbar">
      <div class="left">
         <div class="page-heading">
            <h2 class="page-title">Extension Group - {{ extensionGroup?.name }}</h2>
         </div>
      </div>
      <div class="right context-actions">
         <button
            type="button"
            mat-button
            [matMenuTriggerFor]="updateDetailsMenu"
            matTooltip="Info"
            aria-label="eg-Info"
            id="extension-group-detail-info"
         >
            <mat-icon>info</mat-icon>
         </button>
         @if (canDelete()) {
         <button
            type="button"
            mat-button
            [matMenuTriggerFor]="promptMenu"
            aria-label="Extension-Group Actions"
            matTooltip="More Actions"
            id="extension-group-detail-more-actions"
         >
            <mat-icon>more_horiz</mat-icon>
         </button>
         }
      </div>
   </div>
   <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <ndt-two-column-layout>
         <div ndtLeftColumn>
            <div class="details-wrapper">
               @if (extensionGroup?.name) {
               <h5>Display Name</h5>
               <div class="detail-item">{{ extensionGroup.name }}</div>
               } @if (extensionGroup?.account?.accountId) {
               <h5>Description</h5>
               <div class="detail-item typeId">{{ extensionGroup?.description }}</div>
               }
            </div>
         </div>
         <div ndtRightColumn>
            <mat-tab-group class="detail-tab-group" (selectedTabChange)="onTabChange($event)" ndt-tab-router
               ><mat-tab [label]="'Extension Group'">
                  <div class="mat-tab-indented">
                     <div class="detail-right-column">
                        <mat-form-field class="flex-half">
                           <mat-label>Display Name</mat-label>
                           <input
                              matInput
                              autocomplete="off"
                              type="text"
                              [value]="extensionGroup?.name"
                              formControlName="name"
                              id="name"
                              required
                           />
                           @if (form.get('name')?.hasError('required')) {
                           <mat-error> Name is required. </mat-error>
                           } @if (form.get('name')?.hasError('noContent')) {
                           <mat-error> Name must contain characters. </mat-error>
                           }
                        </mat-form-field>
                        <mat-form-field class="flex-half">
                           <mat-label>Description</mat-label>
                           <input
                              matInput
                              autocomplete="off"
                              type="text"
                              [value]="extensionGroup?.description"
                              formControlName="description"
                              id="description"
                           />
                        </mat-form-field>
                     </div>
                     <div class="extension-group-members-section">
                        <div class="flex-half extension-multi-select">
                           <ndt-extension-advanced-multi-select
                              [accountIdFilter]="extensionGroup?.account?.accountId ?? null"
                              [itemsControl]="form.controls.extensionGroupExtensions"
                              [extensionTypesToInclude]="extensionGroupMemberTypes"
                              (change)="emitExtensionGroupExtensionsChange()"
                           ></ndt-extension-advanced-multi-select>
                        </div>
                     </div>
                  </div>
               </mat-tab>
               <mat-tab [label]="callLogsTabLabel">
                  @if (extensionGroup?.extensions?.items && callLogsLoaded) {
                  <ndt-call-logs-register [extensionIds]="extensionGroup?.extensions?.items"></ndt-call-logs-register>
                  }
               </mat-tab>
            </mat-tab-group>
         </div>
      </ndt-two-column-layout>
      <ndt-form-footer (cancel)="onCancel()" [visible]="form.dirty" [callState]="callState"></ndt-form-footer>
   </form>
</lcs-loading-overlay>
<mat-menu #promptMenu="matMenu">
   @if (canDelete()) {
   <button mat-menu-item type="button" (click)="onDeleteClick()" id="menu-prompt-delete"> Delete </button>
   }
</mat-menu>
<mat-menu #updateDetailsMenu="matMenu">
   <update-details
      [createUser]="extensionGroup?.createUser"
      [createDate]="extensionGroup?.createDate"
      [updateUser]="extensionGroup?.updateUser"
      [updateDate]="extensionGroup?.updateDate"
   ></update-details>
</mat-menu>
